import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELD = {
  MINISITE: {
    name: 'minisite',
    label: 'Choose a minisite:',
    rules: [{ required: true, message: 'Minisite is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  LOCATIONS: {
    name: 'locations',
    label: 'Current locations',
  },
  TITLE: {
    name: 'title',
    label: 'Module title:',
    placeholder: 'Enter a title for the gallery',
    rules: [{ required: true, message: 'Title is required' }],
  },
};

export const LOCATION_FORM_FIELD = {
  LOCATION: {
    name: 'location',
    label: 'Choose the location you want to include:',
    rules: [{ required: true }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  HEADLINE: {
    name: 'headline',
    label: 'Headline:',
    placeholder: 'Enter a headline',
    rules: [{ required: true, message: 'Headline is required' }],
  },
  DESCRIPTION: {
    name: 'description',
    label: 'Description:',
    rules: [{ required: true, message: 'Description is required' }],
  },
  LINK: {
    name: 'link',
    label: 'Link:',
    placeholder: 'Enter a link',
    rules: [{ type: 'url', message: "Doesn't look like a valid URL" }],
  },
  IMAGE: {
    name: 'image',
    label: 'Featured image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['700x460'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
};

export const INITIAL_VALUES = {
  [FORM_FIELD.LOCATIONS.name]: [],
};
